<div id="layout-wrapper">
    <!-- Top Bar -->

    <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()" (settingsButtonClicked)="onSettingsButtonClicked()">
    </app-topbar>
    <app-sidebar></app-sidebar>
    <!-- Mobile backdrop — visible only when the sidebar drawer is open
         (body.sidebar-enable). Tapping it closes the drawer. -->
    <div class="mobile-sidebar-backdrop d-lg-none"
         *ngIf="mobileMenuOpen"
         (click)="onToggleMobileMenu()"></div>
    <div class="main-content" id="mainContent">
        <div class="page-content">
            <div class="container-fluid">
                <!-- content -->
                <router-outlet></router-outlet>
            </div>
        </div>
        <!-- footer -->
        <app-footer></app-footer>
    </div>
</div>